export const isTokenExpired = (expiryTime: number) => {
  return new Date().getTime() - expiryTime > 0;
};

export const getMetadata = (
  token: string,
  extraHeaders: Record<string, any> = {}
): Headers => {
  const headers = new Headers();

  if (process.env.NODE_ENV === "development" && !!process.env.VUE_APP_ACCESS_TOKEN) {
    headers.set("authorization", `Bearer ${process.env.VUE_APP_ACCESS_TOKEN}`);
  } else {
    headers.set("authorization", `Bearer ${token}`);
  }

  for (const key in extraHeaders) {
    const value = extraHeaders[key];
    headers.set(key, value);
  }
  return headers;
};

export const clearData = () => {
  localStorage.removeItem("internal-admin.brank.as");
};

export default {
  getMetadata,
  isTokenExpired,
  clearData,
};
